<template>
  <div class="hello">
    <remindListTop @event3="change3($event)" @transformVal="getVal" @exportMethod="exportHandle" :exportStatus="exportLoading" @fatherMethod="getremindlist"></remindListTop>
    <!-- <injury v-if="isHandled==0"></injury>
      <injuryProcessed v-if="isHandled==1"></injuryProcessed> -->
    <div class="contract">
      <div class="main-con">
        <div class="crumbs">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>通知</el-breadcrumb-item>
            <el-breadcrumb-item>待办事项</el-breadcrumb-item>
            <el-breadcrumb-item>工伤纠纷提醒</el-breadcrumb-item>
            <el-breadcrumb-item>
              <span v-show="isHandled =='0'">待处理</span>
              <span v-show="isHandled =='1'">已处理</span>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="idCardTable">
          <el-table :data="tableData" :max-height="tableHeight-180" style="width: 99%" stripe v-loading="listLoading" @cell-click="editTable">
            <!-- <el-table-column align="center" type="selection" width="50px"></el-table-column> -->
            <el-table-column align="center" label="序号" prop="num" width="50"></el-table-column>
            <el-table-column align="center" label="项目名称" prop="StrObjName" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="档案号" prop="StrFileNo" min-width="120px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="姓名" prop="StrEmpName" min-width="70px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="身份证号码" prop="StrIdCard" min-width="160px" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="合同（协议）类型" prop="StrContractType" fit :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" label="伤残等级" prop="StrDisabilityLevel" fit :show-overflow-tooltip="true">
              <template slot-scope="{row}">
                <span>{{row.StrDisabilityLevel}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="工伤纠纷发生时间" prop="DtInjuryBdate" min-width="110px" fit :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{isNull(scope.row.DtInjuryBdate)?'':scope.row.DtInjuryBdate.replace('T',' ')}}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="工伤纠纷结束时间" prop="DtInjuryEdate" min-width="110px">
                <template slot-scope="scope">
                  <span>{{isNull(scope.row.DtInjuryEdate)?'':scope.row.DtInjuryEdate.replace('T',' ')}}</span>
                </template>
              </el-table-column> -->
            <el-table-column align="center" fixed="right" label="操作" min-width="220px">
              <template slot-scope="{row}">
                <el-button type="success" size="small" plain @click="editHandle(row)">修改伤残等级</el-button>
                <el-button type="warning" size="small" plain @click="addHandle(row)" v-if="isHandled =='0'">确认处理</el-button>
                <el-button type="warning" size="small" plain @click="revokeHandle(row)" v-if="isHandled == '1'">撤销处理</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" v-show="totalcount>0">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage3" :page-size="pagecount" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
          </div>
        </div>
      </div>
      <el-dialog title="确认处理" :visible.sync="dialogVisible" width="30%">
        <span>若您已在线下完成处理，无需再进行其他线上操作，请点击确认</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible = false">取消</button>
          <button class="search" @click="changeSolve" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="撤销处理" :visible.sync="dialogVisible3" width="30%">
        <span>点击“撤销处理”后，本条待办事项将重新在“待办事项”列表中</span>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible3 = false">取消</button>
          <button class="search" @click="revokeSubmit" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
      <el-dialog title="修改伤残等级" :visible.sync="editVisible" width="600px">
        <el-form ref="levelForm" :model="levelForm" label-width="80px">
          <el-form-item label="伤残等级:">
            <el-select v-model="levelForm.cluvalue" placeholder="请选择伤残等级">
              <el-option value="一级"></el-option>
              <el-option value="二级"></el-option>
              <el-option value="三级"></el-option>
              <el-option value="四级"></el-option>
              <el-option value="五级"></el-option>
              <el-option value="六级"></el-option>
              <el-option value="七级"></el-option>
              <el-option value="八级"></el-option>
              <el-option value="九级"></el-option>
              <el-option value="十级"></el-option>
              <el-option value="无等级"></el-option>
              <el-option value="工亡"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="editVisible = false">取消</button>
          <button class="search" @click="changeLevel" style="margin-left:10px;font-weight:600">确定</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import xz from "./../../common";
  import remindListTop from "./components/remindListTop.vue";
  // import injury from "./injury";
  // import injuryProcessed from "./injuryProcessed";
  export default {
    components: {
      remindListTop
    },
    data() {
      return {
        tableHeight: 0,
        listLoading: false,
        isHandled: 0,
        totalcount: 0,
        currpage: 1,
        status: 0,
        editVisible: false,
        dialogVisible: false,
        dialogVisible3: false,
        currentPage3: 1,
        remindQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 10,
          currpage: 1,
          content: 'hurt',
          strstatus: "0",
          strempname: ""
        },
        exportQuery: {
          tableid: "XZ_emp_UserBase",
          pagecount: 100000,
          currpage: 1,
          content: 'hurt',
          strstatus: "0",
          strempname: ""
        },
        pagecount: 10,
        tableData: [],
        //确认处理参数-档案号
        strfileno: '',
        //修改伤残等级
        levelForm: {
          tableid: "XZ_emp_UserBase",
          excelpath: '',
          execlline: '',
          cluname: '',
          cluvalue: ''
        },
        //导出按钮加载状态
        exportLoading: false,
        info: {},
      }
    },
    mounted() {
      this.calHeight();
      this.getremindlist();
    },
    methods: {
      //一键导出
      exportHandle() {
        this.exportLoading = true
        xz.outputQueryEmpCust(this.exportQuery).then(res => {
          // console.log('process', res)
          if (res.status == 'ok') {
            this.$router.push({
              path: "/operationRecord",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                //qStstus=1时查看最后一条导出记录
                qStstus: 1
              }
            })
          } else {
            this.$message({
              message: "导出错误，请稍后再试",
              type: "error"
            });
          }
          this.exportLoading = false
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      change3(data) {
        this.isHandled = data;
        this.remindQuery.strstatus = data
        this.remindQuery.currpage = 1
      },
      //判断是否为空(包含0)或1970
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == '1900-01-01T00:00:00' || o == '1900-01-01' || o == '1900/01/01';
      },
      getVal(data) {
        // console.log('名称',data)
        this.remindQuery.strempname = data
      },
      editTable(row, column, cell, event) {
        //  console.log('row',row,column,cell,event)
        this.levelForm.tableid = "XZ_emp_UserBase"
        this.levelForm.excelpath = row.StrExcelPath
        this.levelForm.execlline = row.IntExcelLine
        this.levelForm.cluname = "StrDisabilityLevel" //column.property
      },
      //修改伤残等级
      editHandle(row) {
        this.editVisible = true
      },
      //确定修改伤残等级
      changeLevel() {
        if (this.isNull(this.levelForm.cluvalue)) {
          this.$message({
            message: "请选择伤残等级",
            type: "warning"
          });
          return false
        } else {
          // console.log('lkl',this.levelForm)
          xz.editEmployeeInfo(this.levelForm).then(res => {
            if (res == true) {
              this.$message({
                message: "伤残等级修改成功！",
                type: "success"
              });
              this.editVisible = false
              this.getremindlist();
            } else {
              this.$message.error("伤残等级修改失败！");
            }
          });
        }
      },
      //分页转跳
      handleCurrentChange(val) {
        this.currpage = `${val}`;
        this.remindQuery.currpage = `${val}`;
        this.getremindlist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.remindQuery.pagecount = `${val}`;
        this.pagecount = parseInt(val);
        this.getremindlist();
      },
      addHandle(row) {
        console.log('row', row)
        this.info = row;
        this.dialogVisible = true;
        this.strfileno = row.StrFileNo
        console.log('strfileno', this.strfileno)
      },
      //确认处理
      changeSolve() {
        let d = {
          status: 1, //1 处理，0 退回
          content: 'hurt',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "处理成功！",
              type: "success"
            });
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible = false;
        });
      },
      //确认撤销
      revokeHandle(row) {
        this.info = row;
        this.dialogVisible3 = true;
        this.strfileno = row.StrFileNo
      },
      //确认撤销处理
      revokeSubmit() {
        let d = {
          status: 0, //1 处理，0 退回
          content: 'hurt',
          StrExcelPath: this.info.StrExcelPath,
          IntExcelLine: this.info.IntExcelLine,
        }
        xz.updatecustBystrfileNo(d, localStorage.loginRoletype).then(res => {
          //  console.log('处理',res)
          if (res.status == 'ok') {
            this.$message({
              message: "撤销成功！",
              type: "success"
            });
            this.dialogVisible3 = false;
            this.getremindlist();
            //侧边栏数量重新查询
            this.$store.commit("getLeftNum");
          } else {
            this.$message.error(res.msg);
          }
          this.dialogVisible3 = false;
        });
      },
      //获取待办事项列表
      getremindlist() {
        console.log('待办事项列表', this.remindQuery)
        // this.tableData = []
        this.listLoading = true
        xz.getremindlist(this.remindQuery).then(res => {
          console.log('待办事项列表', res)
          if (res) {
            if (res.data && res.data.length > 0) {
              let i = 1 + (this.currpage - 1) * 10;
              res.data.forEach(l => {
                l.DtInjuryBdate ? (l.DtInjuryBdate = l.DtInjuryBdate.substring(0, 10)) : '-';
                l.DtInjuryEdate ? (l.DtInjuryEdate = l.DtInjuryEdate.substring(0, 10)) : '-';
                l['num'] = i++;
              });
              this.tableData = res.data;
              this.totalcount = parseInt(res.count);
            } else {
              this.tableData = []
              this.totalcount = 0
            }
          }
          this.listLoading = false
        })
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .changeState1 {
    padding: 5px 10px;
    border: solid 1px #c2e7b0;
    color: #67c23a;
    border-radius: 4px;
    background-color: #fff;
    margin-right: 5px;
  }
</style>